import { generateSelectedCategoryArray } from "@faire/retailer-visitor-shared/components/Filter/filter-components/generateSelectedCategoryArray";
import { useSearchPageFilteredFilterSections } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageFilteredFilterSections";
import { IFilterOption } from "@faire/web-api--source/indigofair/data/IFilterOption";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import { useMemo } from "react";

export const useSearchPageSelectedCategoryFiltersArray = () => {
  const filterSections = useSearchPageFilteredFilterSections();

  return useMemo(() => {
    const categoryFilterSection = filterSections.find(
      (section: IFilterSection) =>
        section.field_name === IFilterSection.FieldName.CATEGORY
    );
    const categoryFilterOptions = categoryFilterSection?.options ?? [];

    return categoryFilterOptions.reduce<IFilterOption[]>((acc, option) => {
      return [...acc, ...generateSelectedCategoryArray(option)];
    }, []);
  }, [filterSections]);
};
